<template>
    <div class="main-cn high-value-page">
        <div class="main-bd mg20">
            <div class="filter-card">
                <el-form :inline="true" :model="searcherModel" size="small" class="filter-form">
                    <el-form-item label="客户标签">
                        <el-select v-model="searcherModel.tags" placeholder="请选择标签" multiple collapse-tags clearable>
                            <el-option label="规模大" value="scale"></el-option>
                            <el-option label="意向高" value="intention"></el-option>
                            <el-option label="试用中" value="trial"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="产品剩余时间不满">
                        <el-select v-model="searcherModel.remain_within" placeholder="剩余时间" clearable>
                            <el-option label="1周" value="1w"></el-option>
                            <el-option label="2周" value="2w"></el-option>
                            <el-option label="1月" value="1m"></el-option>
                            <el-option label="3月" value="3m"></el-option>
                            <el-option label="6月" value="6m"></el-option>
                            <el-option label="1年" value="1y"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="产品">
                        <Product ref="product" :clearable="true" @change="handleProductChange"></Product>
                    </el-form-item>
                    <el-form-item label="所在地区">
                        <div class="district-wrap">
                            <DistrictCascader ref="district" @change="handleDistrictChange"></DistrictCascader>
                        </div>
                    </el-form-item>
                    <el-form-item label="客户名称">
                        <div class="customer-select-wrap">
                            <CustomerSelect
                                ref="CustomerSelect"
                                :customer-idss="searcherModel.name"
                                placeholder="请输入客户名称"
                                @change="CustomerHandleChange">
                            </CustomerSelect>
                        </div>
                    </el-form-item>
                    <el-form-item label="客户创建时间">
                        <el-date-picker
                            v-model="createdRange"
                            type="daterange"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            value-format="yyyy-MM-dd"
                            unlink-panels>
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item label="最后跟进时间">
                        <el-date-picker
                            v-model="traceRange"
                            type="daterange"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            value-format="yyyy-MM-dd"
                            unlink-panels>
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" icon="el-icon-search" @click="submitSearch">搜索</el-button>
                        <el-button icon="el-icon-refresh" @click="resetForm">重置</el-button>
                    </el-form-item>
                </el-form>
            </div>

            <div class="table-card">
                <div class="table-head">
                    <div class="table-title">
                        高价值客户推荐列表
                        <el-tooltip placement="top" effect="dark">
                            <div slot="content">
                                高价值客户判定标准：基于客户规模（班级数≥20为规模大）、客户意向（跟进记录关键词分析）、订单状态（试用中）多维度综合判定
                            </div>
                            <i class="el-icon-question title-tip"></i>
                        </el-tooltip>
                    </div>
                    <div class="table-actions">
                        <span class="welfare-label">过滤公益行客户</span>
                        <el-switch v-model="filterWelfare" @change="submitSearch"></el-switch>
                        <el-button size="small" icon="el-icon-refresh" @click="submitSearch">刷新</el-button>
                    </div>
                </div>

                <el-table :data="list" v-loading="loading" class="high-value-table">
                    <el-table-column type="index" label="序号" width="55" :index="rowIndex"></el-table-column>
                    <el-table-column label="客户名称" min-width="180">
                        <template slot-scope="scope">
                            <span
                                class="customer-name"
                                @mouseenter="showPreview(scope.row, $event, 'name')"
                                @mouseleave="hidePreview"
                                @click="goInsight(scope.row)">{{ scope.row.name }}</span>
                            <el-tag v-if="scope.row.school_type_name" size="mini" class="school-tag" :class="scope.row.school_type === 2 ? 'public-tag' : 'private-tag'">
                                {{ scope.row.school_type_name }}
                                <span v-if="scope.row.school_type_ai" class="ai-badge">+ AI</span>
                            </el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column label="客户标签" width="160">
                        <template slot-scope="scope">
                            <el-tag
                                v-for="tag in scope.row.tags"
                                :key="tag.code"
                                size="mini"
                                class="value-tag"
                                :class="['tag-' + tag.code, tag.level === '中' ? 'tag-intention-mid' : (tag.level === '低' ? 'tag-intention-low' : '')]">
                                {{ tag.name }}
                                <span v-if="tag.ai" class="ai-badge">+ AI</span>
                            </el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column label="班级数" prop="class_num" width="80">
                        <template slot-scope="scope">
                            <span>{{ scope.row.class_num === null || scope.row.class_num === '' ? '' : scope.row.class_num }}</span>
                            <span v-if="scope.row.class_num_ai" class="ai-badge">+ AI</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="申请产品" min-width="140" show-overflow-tooltip>
                        <template slot-scope="scope">
                            <span v-if="scope.row.apply_products && scope.row.apply_products.length" class="apply-products">
                                {{ applyProductText(scope.row.apply_products) }}
                            </span>
                            <span v-else>—</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="试用产品" width="200">
                        <template slot-scope="scope">
                            <div v-if="scope.row.trial_products && scope.row.trial_products.length == 1" class="product-buyed">
                                <p>{{ scope.row.trial_products[0].product_name }}
                                    <span style="color:red;" v-if="scope.row.trial_products[0].expired">试用到期</span>
                                </p>
                                <p>{{ scope.row.trial_products[0].start_at }}~{{ scope.row.trial_products[0].end_at }}</p>
                            </div>
                            <el-dropdown v-else-if="scope.row.trial_products && scope.row.trial_products.length > 1">
                                <span class="el-dropdown-link product-buyed">
                                    <p>{{ scope.row.trial_products[0].product_name }}
                                        <span style="color:red;" v-if="scope.row.trial_products[0].expired">试用到期</span>
                                    </p>
                                    <p>{{ scope.row.trial_products[0].start_at }}~{{ scope.row.trial_products[0].end_at }}</p>
                                </span>
                                <el-dropdown-menu slot="dropdown">
                                    <el-dropdown-item v-for="item in scope.row.trial_products" :key="item.product_id">
                                        <p>{{ item.product_name }}
                                            <span style="color:red;" v-if="item.expired">试用到期</span>
                                        </p>
                                        <p>{{ item.start_at }}~{{ item.end_at }}</p>
                                    </el-dropdown-item>
                                </el-dropdown-menu>
                            </el-dropdown>
                            <span v-else>—</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="距离到期" width="130">
                        <template slot-scope="scope">
                            <div v-if="scope.row.remain_items && scope.row.remain_items.length == 1" class="remain-item">
                                {{ scope.row.remain_items[0].product_name }} <span class="remain-days">{{ scope.row.remain_items[0].remain_days }}天</span>
                            </div>
                            <el-dropdown v-else-if="scope.row.remain_items && scope.row.remain_items.length > 1">
                                <span class="el-dropdown-link remain-item">
                                    {{ scope.row.remain_items[0].product_name }} <span class="remain-days">{{ scope.row.remain_items[0].remain_days }}天</span>
                                </span>
                                <el-dropdown-menu slot="dropdown">
                                    <el-dropdown-item v-for="item in scope.row.remain_items" :key="item.product_id">
                                        {{ item.product_name }} <span class="remain-days">{{ item.remain_days }}天</span>
                                    </el-dropdown-item>
                                </el-dropdown-menu>
                            </el-dropdown>
                            <span v-else>—</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="最后跟进时间" prop="last_trace_at" width="170">
                        <template slot-scope="scope">
                            {{ scope.row.last_trace_at || '—' }}
                        </template>
                    </el-table-column>
                    <el-table-column label="客户创建时间" prop="created_at" width="170">
                        <template slot-scope="scope">
                            {{ scope.row.created_at || '—' }}
                        </template>
                    </el-table-column>
                    <el-table-column label="所在地区" min-width="140" show-overflow-tooltip>
                        <template slot-scope="scope">
                            {{ scope.row.district_names || '—' }}
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" width="150">
                        <template slot-scope="scope">
                            <el-button
                                type="text"
                                icon="el-icon-view"
                                @mouseenter.native="showPreview(scope.row, $event, 'insight')"
                                @mouseleave.native="hidePreview"
                                @click="goInsight(scope.row)">智能客户洞察</el-button>
                        </template>
                    </el-table-column>
                </el-table>

                <div
                    ref="previewFloat"
                    v-show="previewVisible && previewRow"
                    class="insight-preview-float"
                    :style="previewStyle"
                    @mouseenter="keepPreview"
                    @mouseleave="hidePreview">
                    <i class="insight-preview-arrow" :class="{ 'is-right': previewFrom === 'insight' }" :style="{ top: previewArrowTop + 'px' }"></i>
                    <high-value-insight-preview
                        v-if="previewRow"
                        :data="previewMap[previewRow.id]"
                        :loading="!!previewLoading[previewRow.id]"
                        @open-full="goInsight(previewRow)">
                    </high-value-insight-preview>
                </div>

                <div class="table-pager">
                    <MyPagination :linkPage="linkPage" :pageSizes="[10, 20, 30, 50]" @size-change="handleSizeChange" @current-change="handleCurrentChange"></MyPagination>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import CustomerService from "~/services/customer";
import Product from "~/widgets/Product.vue";
import DistrictCascader from "~/widgets/DistrictCascader.vue";
import MyPagination from "~/widgets/MyPagination.vue";
import HighValueInsightPreview from "~/widgets/HighValueInsightPreview.vue";
import CustomerSelect from "~/widgets/CustomerSelect.vue";

export default {
    name: "HighValueCustomers",
    components: {
        Product,
        DistrictCascader,
        MyPagination,
        HighValueInsightPreview,
        CustomerSelect,
    },
    data() {
        return {
            loading: false,
            list: [],
            linkPage: null,
            filterWelfare: true,
            createdRange: [],
            traceRange: [],
            previewMap: {},
            previewLoading: {},
            previewRow: null,
            previewVisible: false,
            previewTimer: null,
            previewTriggerRect: null,
            previewFrom: "name",
            previewArrowTop: 24,
            previewStyle: {},
            searcherModel: {
                tags: [],
                remain_within: '',
                product_id: '',
                province_id: 0,
                city_id: 0,
                district_id: 0,
                name: '',
                id: '',
                page: 1,
                perPage: 20,
            },
        };
    },
    created() {
        this.submitSearch();
    },
    mounted() {
        if (this.$refs.previewFloat) {
            document.body.appendChild(this.$refs.previewFloat);
        }
        this._onPreviewWin = () => {
            if (this.previewVisible) {
                this.updatePreviewPosition();
            }
        };
        window.addEventListener("scroll", this._onPreviewWin, true);
        window.addEventListener("resize", this._onPreviewWin);
    },
    beforeDestroy() {
        this.clearPreviewTimer();
        if (this._onPreviewWin) {
            window.removeEventListener("scroll", this._onPreviewWin, true);
            window.removeEventListener("resize", this._onPreviewWin);
        }
        const el = this.$refs.previewFloat;
        if (el && el.parentNode) {
            el.parentNode.removeChild(el);
        }
    },
    methods: {
        applyProductText(products) {
            return products.map(item => item.product_name).join('、');
        },
        handleProductChange(value) {
            this.searcherModel.product_id = value;
        },
        handleDistrictChange(value) {
            this.searcherModel.province_id = parseInt(value[0] || 0);
            this.searcherModel.city_id = parseInt(value[1] || 0);
            this.searcherModel.district_id = parseInt(value[2] || 0);
        },
        CustomerHandleChange(object) {
            if (object && object.sensitive_masked) {
                this.searcherModel.name = '';
                this.searcherModel.id = object.query_value || object.label || '';
                return;
            }
            this.searcherModel.name = object && object.value ? object.value : '';
            this.searcherModel.id = object && object.label ? object.label : '';
        },
        buildParams() {
            let params = _.clone(this.searcherModel);
            params.filter_welfare = this.filterWelfare ? 1 : 0;
            if (Array.isArray(params.tags)) {
                params.tags = params.tags.join(',');
            }
            if (this.createdRange && this.createdRange.length === 2) {
                params.created_at_start = this.createdRange[0];
                params.created_at_end = this.createdRange[1];
            }
            if (this.traceRange && this.traceRange.length === 2) {
                params.trace_at_start = this.traceRange[0];
                params.trace_at_end = this.traceRange[1];
            }
            _.each(params, (val, key) => {
                if (key === 'filter_welfare' || key === 'page' || key === 'perPage') {
                    return;
                }
                if (val === undefined || val === null || val === '' || val === 0) {
                    delete params[key];
                }
            });
            return params;
        },
        submitSearch() {
            this.searcherModel.page = 1;
            this.getList(this.buildParams());
        },
        resetForm() {
            this.filterWelfare = true;
            this.createdRange = [];
            this.traceRange = [];
            this.searcherModel = {
                tags: [],
                remain_within: '',
                product_id: '',
                province_id: 0,
                city_id: 0,
                district_id: 0,
                name: '',
                id: '',
                page: 1,
                perPage: this.searcherModel.perPage || 20,
            };
            if (this.$refs.product) {
                this.$refs.product.reset();
            }
            if (this.$refs.district) {
                this.$refs.district.reset();
            }
            if (this.$refs.CustomerSelect) {
                this.$refs.CustomerSelect.reset();
            }
            this.submitSearch();
        },
        getList(params) {
            this.loading = true;
            CustomerService.getHighValueList(params).then(res => {
                if (res.code == 0) {
                    this.list = res.data || [];
                } else {
                    this.list = [];
                    this.$message.error(res.msg || '获取列表失败');
                }
                if (res._meta) {
                    this.linkPage = {
                        ...res._meta,
                        currentPage: parseInt(res._meta.currentPage),
                        perPage: parseInt(res._meta.perPage),
                        totalCount: parseInt(res._meta.totalCount),
                        pageCount: parseInt(res._meta.pageCount)
                    };
                }
                this.loading = false;
            }).catch(() => {
                this.loading = false;
            });
        },
        handleSizeChange(newSize) {
            this.searcherModel.perPage = parseInt(newSize);
            this.searcherModel.page = 1;
            this.getList(this.buildParams());
        },
        handleCurrentChange(newPage) {
            this.searcherModel.page = parseInt(newPage);
            this.getList(this.buildParams());
        },
        rowIndex(index) {
            const page = this.linkPage && this.linkPage.currentPage ? parseInt(this.linkPage.currentPage) : 1;
            const perPage = this.linkPage && this.linkPage.perPage ? parseInt(this.linkPage.perPage) : (this.searcherModel.perPage || 20);
            return (page - 1) * perPage + index + 1;
        },
        showPreview(row, evt, from) {
            this.clearPreviewTimer();
            if (!row) {
                return;
            }
            this.previewRow = row;
            this.previewFrom = from || "name";
            this.previewVisible = true;
            if (evt && evt.currentTarget) {
                this.previewTriggerRect = evt.currentTarget.getBoundingClientRect();
            }
            this.loadPreview(row);
            this.$nextTick(this.updatePreviewPosition);
        },
        keepPreview() {
            this.clearPreviewTimer();
        },
        hidePreview() {
            this.clearPreviewTimer();
            this.previewTimer = setTimeout(() => {
                this.previewVisible = false;
                this.previewRow = null;
            }, 180);
        },
        clearPreviewTimer() {
            if (this.previewTimer) {
                clearTimeout(this.previewTimer);
                this.previewTimer = null;
            }
        },
        updatePreviewPosition() {
            const el = this.$refs.previewFloat;
            const rect = this.previewTriggerRect;
            if (!el || !rect || !this.previewVisible) {
                return;
            }
            const gap = 14;
            const maxH = window.innerHeight - 24;
            let width, left, top, height;
            if (this.previewFrom === "insight") {
                const leftMin = 200;
                const right = rect.left - gap;
                width = Math.min(980, Math.max(720, right - leftMin));
                left = right - width;
                if (left < 16) {
                    left = 16;
                    width = Math.max(560, right - left);
                }
                el.style.width = width + "px";
                height = Math.min(el.offsetHeight || maxH, maxH);
                top = 24;
                if (height < window.innerHeight - 80) {
                    top = Math.max(24, Math.round((window.innerHeight - height) / 2));
                }
            } else {
                width = Math.min(920, Math.max(640, window.innerWidth - rect.right - gap - 24));
                el.style.width = width + "px";
                height = Math.min(el.offsetHeight || maxH, maxH);
                left = rect.right + gap;
                if (left + width > window.innerWidth - 16) {
                    left = Math.max(16, window.innerWidth - width - 16);
                }
                top = rect.top + rect.height / 2 - height / 2;
                top = Math.max(12, Math.min(top, window.innerHeight - height - 12));
            }
            let arrowTop = rect.top + rect.height / 2 - top - 7;
            arrowTop = Math.max(18, Math.min(arrowTop, height - 28));
            this.previewArrowTop = arrowTop;
            this.previewStyle = {
                top: top + "px",
                left: left + "px",
                width: width + "px",
            };
        },
        loadPreview(row) {
            if (!row || !row.id || this.previewMap[row.id] || this.previewLoading[row.id]) {
                this.$nextTick(this.updatePreviewPosition);
                return;
            }
            this.$set(this.previewLoading, row.id, true);
            CustomerService.getHighValuePreview(row.id).then(res => {
                this.$set(this.previewLoading, row.id, false);
                if (res.code == 0) {
                    this.$set(this.previewMap, row.id, res.data || {});
                }
                this.$nextTick(this.updatePreviewPosition);
            }).catch(() => {
                this.$set(this.previewLoading, row.id, false);
                this.$nextTick(this.updatePreviewPosition);
            });
        },
        goInsight(row) {
            let route = this.$router.resolve({
                path: '/customers/insight',
                query: {id: row.id}
            });
            window.open(route.href, '_blank');
        },
    }
}
</script>

<style scoped>
.high-value-page .filter-card,
.high-value-page .table-card {
    background: #fff;
    border-radius: 4px;
    padding: 16px 20px 6px;
    margin-bottom: 16px;
}
.filter-form .el-form-item {
    margin-right: 18px;
}
.district-wrap {
    width: 180px;
}
.customer-select-wrap {
    width: 220px;
}
.table-head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 12px;
}
.table-title {
    font-size: 16px;
    font-weight: 600;
    color: #303133;
}
.title-tip {
    color: #909399;
    cursor: pointer;
    margin-left: 4px;
}
.table-actions {
    display: flex;
    align-items: center;
}
.welfare-label {
    margin-right: 8px;
    color: #606266;
    font-size: 13px;
}
.table-actions .el-button {
    margin-left: 16px;
}
.customer-name {
    color: #409EFF;
    cursor: pointer;
}
.school-tag {
    margin-left: 6px;
    border-width: 1px;
}
.private-tag {
    background: #fdf6ec;
    border-color: #f5dab1;
    color: #e6a23c;
}
.public-tag {
    background: #ecf5ff;
    border-color: #b3d8ff;
    color: #409EFF;
}
.value-tag {
    margin-right: 6px;
    background: #fff;
}
.tag-scale,
.tag-intention {
    color: #f56c6c;
    border-color: #fbc4c4;
    background: #fef0f0;
}
.tag-intention-mid {
    color: #e6a23c;
    border-color: #f5dab1;
    background: #fdf6ec;
}
.tag-intention-low {
    color: #909399;
    border-color: #dcdfe6;
    background: #f4f4f5;
}
.tag-trial {
    color: #409EFF;
    border-color: #b3d8ff;
    background: #ecf5ff;
}
.apply-products {
    color: #409EFF;
}
.high-value-table {
    width: 100%;
}
.product-buyed p {
    margin: 0;
    line-height: 1.4;
    font-size: 12px;
}
.product-buyed .el-dropdown-link,
.el-dropdown-link.product-buyed,
.el-dropdown-link.remain-item {
    cursor: pointer;
}
.remain-item {
    line-height: 1.6;
}
.remain-days {
    color: #f56c6c;
}

.ai-badge {
    display: inline-block;
    margin-left: 4px;
    background: #fb923c;
    color: #fff;
    border-radius: 10px;
    font-size: 11px;
    padding: 0 6px;
    line-height: 16px;
}
.table-pager {
    display: flex;
    justify-content: flex-end;
    padding: 12px 0 8px;
}
.preview-img {
    width: 100%;
    height: 200px;
    object-fit: contain;
}
.preview-empty {
    height: 160px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #909399;
    background: #f5f7fa;
}
.preview-footer {
    text-align: right;
}
</style>

<style>
.insight-preview-float {
    position: fixed;
    top: 12px;
    left: 240px;
    width: 920px;
    max-height: calc(100vh - 24px);
    overflow: visible;
    background: #fff;
    border-radius: 8px;
    box-shadow: 0 12px 40px rgba(15, 23, 42, 0.16);
    padding: 16px 18px 8px;
    z-index: 4000;
}
.insight-preview-arrow {
    position: absolute;
    left: -8px;
    width: 0;
    height: 0;
    border-top: 8px solid transparent;
    border-bottom: 8px solid transparent;
    border-right: 8px solid #fff;
    filter: drop-shadow(-1px 0 1px rgba(15, 23, 42, 0.12));
    pointer-events: none;
}
.insight-preview-arrow.is-right {
    left: auto;
    right: -8px;
    border-right: 0;
    border-left: 8px solid #fff;
    filter: drop-shadow(1px 0 1px rgba(15, 23, 42, 0.12));
}
</style>



// WEBPACK FOOTER //
// src/views/customer/high-value.vue